import React, { useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { Icon } from "components/Icon/Icon";
import { TranslateWrapper } from "components/TranslateWrapper";

export const InfoTooltip = ({ tooltipText }) => {
  const iconRef = useRef(null);

  return (
    <>
      <div ref={iconRef}>
        <Icon
          className="ms-2 text-gray-600 cursor-pointer"
          iconName="circle-info-regular"
          prefix="trox"
          tabIndex={-1}
        />
      </div>
      <UncontrolledTooltip target={iconRef} placement="top" autohide={false}>
        {tooltipText}
      </UncontrolledTooltip>

      {typeof tooltipText === "object" && (
        <TranslateWrapper
          tooltipId={iconRef}
          tooltipText={tooltipText.props.tooltipText}
          placement="bottom"
        />
      )}
    </>
  );
};
